export function FaqItemListSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="rounded-xl border border-border/60 bg-card shadow-sm">
      <ul className="divide-y divide-border/50">
        {[...Array(rows)].map((_, i) => (
          <li key={i} className="flex items-center gap-3 px-4 py-3.5">
            <div className="min-w-0 flex-1 space-y-2">
              <div className="h-4 w-3/4 animate-pulse rounded bg-muted" />
              <div className="h-3 w-1/2 animate-pulse rounded bg-muted/60" />
            </div>
            <div className="flex gap-1">
              <div className="size-8 animate-pulse rounded-lg bg-muted/60" />
              <div className="size-8 animate-pulse rounded-lg bg-muted/60" />
              <div className="size-8 animate-pulse rounded-lg bg-muted/60" />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
